import React from 'react';
import { BanknoteIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { currencies } from '../data/content';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const includes = ['6 tomos principales', '15 días de protocolo', "50 recetas antiinflamatorias", 'Los 6 bonos estratégicos'];
const valueRows = [{
  label: '6 tomos principales',
  value: "USD 25.80"
}, {
  label: '6 bonos complementarios',
  value: "USD 51.00"
}];
const assurances = [{
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: BanknoteIcon,
  label: 'Tarjeta o pago local'
}];
type OfferProps = {
  showUrgency?: boolean;
};
export function Offer({
  showUrgency = true
}: OfferProps) {
  return <section id="oferta" className="bg-white py-20 sm:py-28" aria-labelledby="oferta-title" data-id="element-137" data-mp="2add7fzjbrc0t">
      <div className="mx-auto max-w-5xl px-6" data-id="element-138" data-mp="pk7eriduof7v">
        {showUrgency ? <Reveal data-id="element-139" data-mp="pjpe89k5neu5">
            <div className="rounded-3xl bg-mint-50 px-6 py-10 sm:px-12" data-id="element-140" data-mp="pml91p0phned">
              <CountdownTimer label="COMPRANDO DENTRO DE LAS PRÓXIMAS 24 HORAS" note="Después sube el precio y no vuelve a bajar." data-id="element-141" data-mp="uhqu6lmaay1e" />
              
            </div>
          </Reveal> : null}

        <Reveal className={showUrgency ? 'mt-16' : ''} data-id="element-142" data-mp="13ip1pdvxlnoq">
          <div className="text-center" data-id="element-143" data-mp="6tzj1lchcr1p">
            <h2 id="oferta-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-144" data-mp="6v0qzgy78xf7">
              Elegí tu MegaPack
            </h2>
            <p className="mt-4 text-lg text-ink-soft" data-id="element-145" data-mp="ftw2n8k0izpw">
              Todas las opciones incluyen los 6 bonos estratégicos.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-146" data-mp="3k8m0yu8tq32k">
          <div className="mx-auto mt-12 max-w-3xl overflow-hidden rounded-3xl border border-mint-300 bg-white shadow-lift" data-id="element-147" data-mp="3k9fce8iq9gr1">
            <p className="bg-mint-600 py-2.5 text-center text-sm font-semibold uppercase tracking-[0.16em] text-white" data-id="element-148" data-mp="3o8wf4u6rrzsi">
              Pack completo · el más elegido
            </p>

            <div className="grid gap-10 p-8 sm:p-12 md:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)]" data-id="element-149" data-mp="qfmf07mgm9zv">
              <div data-id="element-150" data-mp="154ij5tleb2v7">
                <h3 className="font-display text-3xl text-ink" data-id="element-151" data-mp="1550qpmdid3if">Pack Completo</h3>
                <ul className="mt-6 space-y-3" data-id="element-152" data-mp="107ie9m0a865o">
                  {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-153" data-mp="cgmt37qc097e">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint-600" aria-hidden="true" data-id="element-154" data-mp="cipqicttd4m5" />
                      <span className="text-[15px] text-ink-soft" data-id="element-155" data-mp="7k4pib6qmgwn">{item}</span>
                    </li>)}
                </ul>

                <dl className="mt-8 space-y-2 border-t border-mint-100 pt-6 text-sm" data-id="element-156" data-mp="hfg5ewtvtu5z">
                  {valueRows.map(row => <div key={row.label} className="flex justify-between gap-4" data-id="element-157" data-mp="1wvygoiohqa07">
                      <dt className="text-ink-muted" data-id="element-158" data-mp="1sveidbs6l0ch">{row.label}</dt>
                      <dd className="text-ink-soft" data-id="element-159" data-mp="1sx7ehx564268">{row.value}</dd>
                    </div>)}
                  <div className="flex justify-between gap-4 font-semibold text-ink" data-id="element-160" data-mp="20dcgyl8tqr0x">
                    <dt data-id="element-161" data-mp="25fbhzoh3dbup">Valor total real</dt>
                    <dd data-id="element-162" data-mp="1qgptdop45lv7">USD 76.80</dd>
                  </div>
                </dl>
              </div>

              <div className="flex flex-col" data-id="element-163" data-mp="1vfatzp8a27k6">
                <p className="text-sm text-ink-muted line-through" data-id="element-164" data-mp="1vg2rj5lfqfd3">USD 76.80</p>
                <p className="mt-1 font-display text-6xl leading-none text-mint-700" style={{
                fontSize: "56px"
              }} data-id="element-165" data-mp="2j66iodhfsmn7">
                  USD 19.99
                </p>
                <p className="mt-4 inline-flex w-fit rounded-full bg-mint-100 px-3 py-1.5 text-sm font-semibold text-mint-800" data-id="element-166" data-mp="29fbvn6wd9j0p">
                  Ahorrás USD 62.81 · 75% off
                </p>

                <div className="mt-8" data-id="element-167" data-mp="323zmdhzvx0ln">
                  <CtaButton className="w-full" data-id="element-168" data-mp="322y9d7zb641a">Quiero el Megapack</CtaButton>
                </div>

                <p className="mt-auto pt-6 text-xs leading-relaxed text-ink-muted" data-id="element-169" data-mp="36vrdpuqv7acu">
                  El precio está expresado en dólares estadounidenses (USD). El
                  cobro se realiza automáticamente en la moneda de tu país al tipo
                  de cambio del momento.
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.04} data-id="element-170" data-mp="149ndo9a4ld6k">
          <div className="mx-auto mt-10 max-w-3xl" data-id="element-171" data-mp="14af9nl7mxcxd">
            <p className="text-center text-sm font-medium text-ink" data-id="element-172" data-mp="21ww3ggh5t8ed">
              Pagás en tu moneda local
            </p>
            <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-173" data-mp="1wxj7954eeoz4">
              {currencies.map(currency => <li key={currency} className="whitespace-nowrap rounded-full bg-mint-50 px-3 py-1.5 text-xs text-ink-soft ring-1 ring-inset ring-mint-200" data-id="element-174" data-mp="1s6azsemmpdol">
                  {currency}
                </li>)}
            </ul>

            <ul className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-3" data-id="element-175" data-mp="2ko5ggzq52fap">
              {assurances.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-176" data-mp="2fv3zmm6dg5oh">
                  <item.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-177" data-mp="2o7e3mm5b0yi5" />
                  {item.label}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}